import { createQueryKeys } from "@lukemorales/query-key-factory";
import { skipToken } from "@tanstack/react-query";

import type { Subscription } from "@/features/billing/models";
import type { Product } from "@/features/products/models";
import {
  getAvailableRefillTypes,
  getCancellationReasons,
  getDietitianForm,
  getMicrodosingCheckInForm,
} from "./common";
import { getIntake } from "./intake";

export const formQueriesStore = createQueryKeys("forms", {
  intake: (productId: Product["id"]) => ({
    queryKey: [productId],
    queryFn: () => getIntake(productId),
  }),

  refill: (subscriptionId: Subscription["id"]) => ({
    queryKey: [subscriptionId],
    contextQueries: {
      types: {
        queryKey: null,
        queryFn: subscriptionId
          ? () => getAvailableRefillTypes(subscriptionId)
          : (skipToken as never),
      },
    },
  }),

  checkIn: (productId: Product["id"]) => ({
    queryKey: [productId],
    queryFn: productId
      ? () => getMicrodosingCheckInForm(productId)
      : (skipToken as never),
  }),

  cancellationReasons: {
    queryKey: null,
    queryFn: getCancellationReasons,
  },

  dietitian: {
    queryKey: null,
    queryFn: getDietitianForm,
  },
});
